import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-124ce606"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "top-open" }

import { ref, computed, type CSSProperties, reactive, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import OpenWpsBridge from '../bridge/OpenWpsBridge';
import DeviceEnvUtil from '../../utils/DeviceEnvUtil';
import UnsupportOpenPage from './UnsupportOpenPage.vue';
import { OpenButtonStyle } from './OpenAppButton.vue';
import DownloadAppButton from './DownloadAppButton.vue';
import AppLinkStat from '../stats/AppLinkStat';
import AbilityParamsUtil from '../bridge/AbilityParamsUtil';
import PageParamsUtil from '../../utils/PageParamsUtil';


export default /*#__PURE__*/_defineComponent({
  __name: 'CommonDownloadButton',
  setup(__props) {

const show_tip = ref(false);
const { t } = useI18n();
const btn_text = ref(t('common.download'));

const openBtn = ref();

const topOpenStyleObj = reactive<OpenButtonStyle>({
  background: '#3B64FC',
  'border-radius': '18px',
  'border-width': '0px',
  width: '280px',
  height: '48px',
  'font-size': '16px',
  color: '#fff',
  'text-decoration-line': 'none',
});

const buttonLayoutStyleObj = reactive({
  height: 'auto',
  'margin-top': 'auto',
  'margin-bottom': '50px',
});

const buttonLayoutStyle = computed(() => {
  return {
    ...buttonLayoutStyleObj,
  } as CSSProperties;
});

const showDownloadTips = ref(false);

function dismiss() {
  show_tip.value = false;
}

function proxyOpen() {
  openBtn.value.$.vnode.el?.click();
}

function download() {
  if (DeviceEnvUtil.isUnsupportDownload()) {
    show_tip.value = true;
  } else {
    show_tip.value = false;
    OpenWpsBridge.download();
  }
  AppLinkStat.eventDownloadClick(
    AbilityParamsUtil.getAbilityName(),
    AbilityParamsUtil.getAbilityBusinessId(),
    PageParamsUtil.getPageUrl(),
    DeviceEnvUtil.getPlatform(),
    `${show_tip.value}`,
  );
}

onMounted(() => {
  if (!DeviceEnvUtil.isUnsupportDownload() && AbilityParamsUtil.isAutoJumpDownload()) {
    setTimeout(() => {
      OpenWpsBridge.download();
    }, 1000);
  }
  showDownloadTips.value = AbilityParamsUtil.isAutoJumpDownload();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "button-root",
    onClick: proxyOpen
  }, [
    _createElementVNode("div", {
      id: "button-layout",
      style: _normalizeStyle(buttonLayoutStyle.value)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(DownloadAppButton, {
          ref_key: "openBtn",
          ref: openBtn,
          onActionDownload: download,
          downloadBtnText: btn_text.value,
          openBtnStyleObj: topOpenStyleObj
        }, null, 8, ["downloadBtnText", "openBtnStyleObj"]),
        _withDirectives(_createElementVNode("div", { class: "download_tip" }, _toDisplayString(_unref(t)('tip.upgradeForMore')), 513), [
          [_vShow, showDownloadTips.value]
        ])
      ])
    ], 4),
    _createVNode(UnsupportOpenPage, {
      show_tip: show_tip.value,
      onDimiss: dismiss
    }, null, 8, ["show_tip"])
  ]))
}
}

})